export default __webpack_public_path__ + "static/media/check-inactive-filter.0bee6cfe.svg";